import types from "../actionTypes";
import setLoaderAction from "./loaderAction";
import { isSessionValid } from "./profileAction";
import * as toastAction from "../actions/toastAction";
import { resetOnLoginModalNotification } from "./loginActions";
import * as apiServices from "../../services/apiServices";
import apiConfig, {
  DEFAULT_ERROR_MESSAGE,
  ERROR_TIMEOUT,
} from "../../App.config";



/************************************ ACTIONS ****************************************/

function setIsNotificationModalShown(isShown) {
  return {
    type: types.SET_IS_NOTIFICATION_SHOWN,
    isShown,
  };
}

function setOnSubmitValue(isOnSubmit) {
  return {
    type: types.SET_ON_SUBMIT,
    isOnSubmit,
  };
}

function setPendingApplications(allPendingApplications) {
  return {
    type: types.SET_PENDING_APPLICATIONS,
    allPendingApplications
  }
}

/************************************ ACTION CREATORS ****************************************/

export const setNotificationShown = (isShown) => (dispatch) => {
  dispatch(setIsNotificationModalShown(isShown));
};

export const resetNotificationShown = () => (dispatch) => {
  dispatch(setIsNotificationModalShown(false));
  dispatch(setPendingApplications([]));
};

export const getAllPendingApplications = (managerId) => (dispatch) => {
  return apiServices
    .getAllPendingApplications(managerId)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setPendingApplications(data.lstEmpInfo));
        if(data.lstEmpInfo.length==0)
         dispatch(resetOnLoginModalNotification(false)); 
        setTimeout(() => {
          dispatch(toastAction.showSuccessMessage(false, ""));
        }, ERROR_TIMEOUT);
      } else {
        if (data.errorMessage) {
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const setOnSubmit = (isOnSubmit) => (dispatch) => {
  dispatch(setOnSubmitValue(isOnSubmit));
}

